import WidgetCard from '../../../../../components/WidgetCard'
import { DEFAULT_FILTER_TYPE_ID_SELECTED, URL_FILTERS } from '../../../../../constants'
import ButtonCreateNew from '../../../../../components/ButtonCreateNew/buttonCreateNew'
import FiltersTableList from '../../../components/FiltersTableList'
import { ACTIONS } from '../../../../../components/PermissionMapper/constants'
import React from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'

const EntityProfileFilter = () => {
  const intl = useIntl()
  const history = useHistory()
  const selectFilterOption = () => {
    history.push(URL_FILTERS)
  }
  return (
    <WidgetCard
      widgetTitle={{
        title: intl.formatMessage({ id: 'playbook.settings.entityFilters' }),
        subTitle: intl.formatMessage({ id: 'filters.profile.description' }),
        bordered: true,
        action: (
          <ButtonCreateNew
            onClick={selectFilterOption}
            title={intl.formatMessage({ id: 'filters.create.button.text' })}
            action={ACTIONS.RULE_SET_CREATE}
          />
        )
      }}
      className="xs-pb-24"
    >
      <FiltersTableList activeFilterTypeId={DEFAULT_FILTER_TYPE_ID_SELECTED} />
    </WidgetCard>
  )
}

export default EntityProfileFilter
